import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { setTextQuery, setThreadFocus } from 'src/redux/slices/open_ai';
import { trackEvent } from 'src/analytics';
import { EVENTS } from 'src/analytics/events';
import { AppType, getCurrentScrren, onPressLogout } from 'src/helpers/rest';

import ChatIcon from 'src/assets/images/web_chat.svg';
import TatvaLogo from 'src/assets/images/tatva_logo.svg';
import HistoryIcon from 'src/assets/images/web_history.svg';
import ProfileIcon from 'src/assets/images/web_profile.svg';
import UploadIcon from 'src/assets/images/web_upload.svg';
import ProfileSelectedIcon from 'src/assets/images/web_profile_selected.svg';
import HistorySelectedIcon from 'src/assets/images/web_history_selected.svg';
import ChatSelectedIcon from 'src/assets/images/web_chat_selected.svg';
import UploadSelectedIcon from 'src/assets/images/web_upload_selected.svg';
import logoutIcon from 'src/assets/images/logout_web.png';

import styles from './index.module.scss';
import { useAppSelector } from 'src/redux/store';

const SidebarBox: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const { version } = useAppSelector(state => state.socket);

    const app = searchParams.get('app') || localStorage.getItem('app');

    const appType: AppType =
        app === 'zymedelite' ? 'zymedelite' :
            app === 'ask_tatva' ? 'ask_tatva' :
                app === 'medeco' ? 'medeco' :
                    'tatva_ai';

    const onPressLogo = () => {
        if (!localStorage.getItem('token')) return;
        navigate(version === 'v1' ? '/v1' : '/');
        dispatch(setThreadFocus(true));
    };

    const onPressNavIcon = (navigateTo: string, tap_on: string) => {
        const currentScreen = getCurrentScrren(location.pathname);
        if (['/pdf-chat', '/'].includes(navigateTo) && navigateTo !== location.pathname) {
            dispatch(setTextQuery(''));
        }
        trackEvent(EVENTS.TAP_ON_BOTTOM_NAV, {
            tap_on: tap_on,
            screen_name: currentScreen,
            utm: true,
            search: window.location.search
        });
        navigate(navigateTo);
    };

    return (
        <div className={styles.sidebar_wrapper}>
            <img src={TatvaLogo} alt='tatva_logo' className={styles.tatva_logo} onClick={onPressLogo} />
            {location.pathname !== '/login' &&
                <div className={styles.nav_options}>
                    <img src={['/', '/v1'].includes(location.pathname) ? ChatSelectedIcon : ChatIcon} className={styles.nav_option} onClick={() => onPressNavIcon(version === 'v1' ? '/v1' : '/', 'Ask')} alt='chat' />
                    <img src={location.pathname === '/history' ? HistorySelectedIcon : HistoryIcon} className={styles.nav_option} onClick={() => onPressNavIcon('/history', 'History')} alt='history' />
                    {appType === 'tatva_ai' &&
                        <>
                            <img src={location.pathname === '/pdf-chat' ? UploadSelectedIcon : UploadIcon} className={styles.nav_option} onClick={() => onPressNavIcon('/pdf-chat', 'Chat PDF')} alt='profile' />
                            <img src={['/profile', '/my-subscription'].includes(location.pathname) ? ProfileSelectedIcon : ProfileIcon} className={styles.nav_option} onClick={() => onPressNavIcon('/profile', 'Profile')} alt='profile' />
                            <img src={logoutIcon} className={styles.nav_option_logout} onClick={onPressLogout} alt='logout' />
                        </>
                    }
                </div>}
        </div>
    );
}

export default SidebarBox;